// Store ID to Store Name mapping
export const STORE_MAPPING = {
  1: 'PH Head Office',
  101: 'Glorietta (101)',
  102: 'Alabang (102)',
  103: 'Trinoma (103)',
  104: 'Manila Bay (104)',
  105: 'Feliz (105)',
  106: 'Gateway (106)',
  107: 'Festival (107)',
  108: 'Nuvali (108)',
  109: 'Evo City (109)'
}

/**
 * Get store name by store ID
 * @param {number|string} storeId - The store ID
 * @returns {string} Store name or 'Unknown Store' if not found
 */
export const getStoreNameById = (storeId) => {
  const id = parseInt(storeId)
  return STORE_MAPPING[id] || `Store ${storeId}`
}

/**
 * Get all store options as array of objects
 * @param {number[]} storeIds - Array of store IDs
 * @returns {Array} Array of store objects with id, name, and label
 */
export const getStoreOptions = (storeIds = []) => {
  if (!Array.isArray(storeIds) || storeIds.length === 0) {
    return []
  }

  return storeIds
    .map(id => ({
      id: parseInt(id),
      name: getStoreNameById(id),
      value: getStoreNameById(id),
      label: getStoreNameById(id)
    }))
    .sort((a, b) => a.id - b.id) // Sort by store ID
}

/**
 * Check if store ID exists in mapping
 * @param {number|string} storeId - The store ID to check
 * @returns {boolean} True if store exists in mapping
 */
export const isValidStoreId = (storeId) => {
  const id = parseInt(storeId)
  return id in STORE_MAPPING
}